import React from "react";

const getWeatherIcon = (type) => {
  const typeToIcon = {
    // Clear conditions
    clear: "☀️",
    sunny: "☀️",
    none: "☀️",
    fair: "🌤",

    // Cloudy conditions
    cloudy: "☁️",
    overcast: "☁️",
    "partly cloudy": "⛅️",
    "mostly cloudy": "🌥",

    // Rain conditions
    rain: "🌧",
    "light rain": "🌦",
    "heavy rain": "🌧",
    drizzle: "🌦",
    showers: "🌦",
    "scattered showers": "🌦",
    "rain showers": "🌦",
    "freezing rain": "🌧",

    // Thunderstorm conditions
    thunderstorm: "⛈",
    "severe thunderstorm": "⛈",
    thunder: "🌩",
    lightning: "⚡️",

    // Snow conditions
    snow: "❄️",
    "light snow": "🌨",
    "heavy snow": "❄️",
    flurries: "🌨",
    blizzard: "❄️",
    "snow showers": "🌨",

    // Mixed precipitation
    sleet: "🌨",
    "rain and snow": "🌨",
    "wintry mix": "🌨",
    hail: "🌨",
    graupel: "🌨",

    // Fog and mist conditions
    fog: "🌫",
    mist: "🌫",
    haze: "🌫",

    // Severe weather
    tornado: "🌪",
    hurricane: "🌀",
    tropical: "🌀",
    "tropical storm": "🌀",
    dust: "💨",
    sandstorm: "💨",
    windy: "💨",

    // Default for unknown conditions
    default: "☀️",
  };

  // Convert type to lowercase and trim for standardization
  const normalizedType = type?.toLowerCase().trim();
  return typeToIcon[normalizedType] || typeToIcon.default;
};

const PrecipitationSection = ({ data }) => {
  // Helper function to format amount with at least 2 digits
  const formatAmount = (amount) => {
    return Number(amount).toFixed(2);
  };

  return (
    <div className="bg-white rounded-lg p-4">
      <div className="space-y-6">
        <div>
          <div className="text-sm text-gray-500 mb-2">LAST 24 HOURS</div>
          <div className="flex items-center gap-2">
            <span className="weather-icon text-xl">
              {getWeatherIcon(data.last24h.type)}
            </span>
            <span>{data.last24h.type}</span>
            <span className="ml-auto">
              {formatAmount(data.last24h.amount)} мм
            </span>
          </div>
        </div>
        <div>
          <div className="text-sm text-gray-500 mb-2">NEXT 24 HOURS</div>
          <div className="flex items-center gap-2">
            <span className="weather-icon text-xl">
              {getWeatherIcon(data.next24h.type)}
            </span>
            <span>{data.next24h.type}</span>
            <span className="ml-auto">
              {formatAmount(data.next24h.amount)} мм
            </span>
          </div>
        </div>
        <div>
          <div className="text-sm text-gray-500 mb-2">NEXT WEEK</div>
          <div className="flex items-center gap-2">
            <span className="weather-icon text-xl">
              {getWeatherIcon(data.nextWeek.type)}
            </span>
            <span>{data.nextWeek.type}</span>
            <span className="ml-auto">
              {formatAmount(data.nextWeek.amount)} мм
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrecipitationSection;
